export default __webpack_public_path__ + "static/webdev2-89bd618ef9b33dce014490adc76038df.jpeg";